export interface PaginationResponse {
    currentPage: number;
    from: number;
    lastPage: number;
    perPage: number;
    to: number;
    total: number;
}

export const emptyPagination: PaginationResponse = {
    currentPage: 1,
    total: 10,
    perPage: 0,
    lastPage: 10,
    to: 0,
    from: 0,
};
